import { render, staticRenderFns } from "./not-found-component.vue?vue&type=template&id=32966d8d&"
import script from "./not-found-component.vue?vue&type=script&lang=js&"
export * from "./not-found-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports